import { render } from "./NewTDAFooter.vue?vue&type=template&id=6a07dd4c&scoped=true"
import script from "./NewTDAFooter.vue?vue&type=script&lang=js"
export * from "./NewTDAFooter.vue?vue&type=script&lang=js"

import "./NewTDAFooter.vue?vue&type=style&index=0&id=6a07dd4c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a07dd4c"]])

export default __exports__